

// import { useAnimate } from "motion/react"
import { useAnimate } from "framer-motion"
import { useEffect, useRef } from "react"
import { motion } from "framer-motion"
import { Card, CardContent, Box, CardHeader, Button, Typography } from "../utils/mui-imports"
import { useNavigate } from "react-router-dom"

/**
 * A comparison of color interpolation between Motion and the Web Animations API.
 * Motion uses RGB interpolation by default, while WAAPI uses HSL interpolation.
 */
export default function CTANewUI({destination, buttonText, heading, subheading, navState}) {

  const navigate = useNavigate()
    

    return (
        <>
            <div
          className="test"
          style={{
            // height: "auto",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ padding: "1.5rem", width: "100%" }}>
          <motion.div
      // animate={{ backgroundColor: ["rgba(255,0,136,1)", "rgba(13,99,248,1)",] }}
      // animate={{ backgroundColor: ["rgb(13, 13, 13)", "rgb(16, 0, 47)",] }}
      animate={{ backgroundColor: ["rgb(32, 24, 17)", "rgb(98, 52, 16)" , "rgba(120, 92, 67, 1)", "rgb(111, 29, 6)"] }}

      
      transition={{
        duration: 100,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "linear",
      }}
      style={{
        // height: "50vh",
        width: "100%",
        backgroundColor: "transparent", // Let the motion.div's background show
        color: "white",
        borderRadius: 8, }}
    >
      <Card
        variant="outlined"
        sx={{
          // height: "100%",
          width: "100%",
          // backdropFilter:'blur(10px)',
          backgroundColor: "transparent", // Let the motion.div's background show
          color: "white",
          borderRadius: 8,
        }}
      >
        <CardHeader
          title={
            <Typography variant="h3" fontWeight="bold"
            //  fontSize="2.25rem"
             >
              {heading}
            </Typography>
          }
          subheader={
            <Typography variant="body1" fontWeight="bold" sx={{ py: 1 }}>
              {subheading}
            </Typography>
          }
        />
        <CardContent>
        {/* <Typography variant="body1" fontWeight="bold" sx={{ py: 1 }}>
        Join <strong>29,330+</strong> others on our waitlist for early access to an exclusive shopping experience.
        </Typography> */}
        <Box
        sx={{
          display:'flex',
          flexDirection:'column',
          gap:2

        }}
        >
        {/* <TextField
        color="primary"
        variant="filled"
        fullWidth label="Email" id="fullWidth" /> */}
        <Button
        variant="contained"
        fullWidth
        onClick={()=>{navigate(destination, {state:navState})}}
        // color="primary"
        sx={{
          backgroundColor:'white',
          fontWeight:'bold',
          color:'black'

        }}
        >{buttonText}</Button>
        </Box>
        </CardContent>
      </Card>
    </motion.div>
          </Box>
        </div>
        </>
    )
}
